var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_440_1",
    "data-name": "Component 440 \\u2013 1",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_885",
    "data-name": "Ellipse 885",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "none",
    stroke: "#656667",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29122",
    "data-name": "Path 29122",
    d: "M11.992,15H12",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#656667",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29123",
    "data-name": "Path 29123",
    d: "M12,12V8",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#656667",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExm);
export default __webpack_public_path__ + "static/media/exm.6280e176a66265ed1f1d95df9f310158.svg";
export { ForwardRef as ReactComponent };